import $ from 'jquery';
import _ from 'lodash-es';

const standardizeHeights = (grid_item_selector, child_selectors) => {

  let offset_top = 0;
  let columns = 0;

  $(grid_item_selector).each((i, grid_item) => {
    if (i === 0) {
      offset_top = $(grid_item).offset().top;
    }

    if (offset_top !== $(grid_item).offset().top) {
      columns = i;
      return false;
    }

    return true;
  });

  if (columns === 0) {
    // All items fit on a single row...don't need columns
    columns = $(grid_item_selector).length;
  }

  $(grid_item_selector).each((i, grid_item) => {
    const remainder = i % columns;
    const number_of_siblings = columns - 1;

    if (remainder === 0) {
      // This is the last grid item on the row
      // Grab all siblings to the right, then slice the correct number of siblings to be left for this row
      const $row_siblings = $(grid_item).nextAll().slice(0, number_of_siblings);
      // Add the current item to the array
      $row_siblings.push($(grid_item)[0]);
      
      _.each(child_selectors, (selector) => {
        let tallest = 0;

        // Remove any hard-coded heights before comparing
        $row_siblings.find(selector).css('height', '');

        // Compare the heights of all siblings and record the tallest
        $row_siblings.each(function() {
          const height = $(this).find(selector).height();

          if (height > tallest) {
            tallest = height;
          }
        });

        $row_siblings.find(selector).height(tallest);
      });
    }
  });
};

export {
  standardizeHeights,
};